import { MoneyWithdrawal } from '@src/types'
import { api, ApiRes } from '@src/utils/api/client'

export interface MoneyWithdrawalsResponse {
    money_withdrawals: MoneyWithdrawal[]
}
export const getMoneyWithdrawals = (
    profile_id: string
): ApiRes<MoneyWithdrawalsResponse> => {
    return api.get(`/manage/money-withdrawals/${profile_id}`)
}
